import { Component, Input } from '@angular/core';
import {CurrencyPipe, DecimalPipe, NgClass} from "@angular/common";

export type CardItem = {
    label: string;
    subLabel?: string;
    value: number | string | null | undefined;
    icon: string;
    color: string;
    bg: string;
    currency?: boolean;
}

@Component({
  selector: 'app-summary-card',
    imports: [
        NgClass,
        DecimalPipe,
        CurrencyPipe,
    ],
  templateUrl: './summary-card.component.html',
  styleUrl: './summary-card.component.scss',
})
export class SummaryCardComponent {
    @Input() items: CardItem[];
    @Input() class?: string;

}
